module.exports = __webpack_public_path__ + "media/images/emblems/Seftigen-coat_of_arms-4c9ec286057b8d2c0500bd3b8d7d6cbe.svg";